import { deleteApiCaller, getApiCaller, postFormDataApiCaller, postApiCaller, putApiCaller, putFormDataApiCaller } from "../apiCaller";

export const getVideoCategories = async (currentPage, itemsPerPage, search, tree = false, parentId = undefined, categoryType = undefined) => {
    const treeParam = tree ? '&tree=true' : '';
    let url = `video-category/get-all?page=${currentPage}&limit=${itemsPerPage}&search=${search}${treeParam}&includeHidden=true`;
    if (parentId !== undefined) {
        url += `&parentId=${parentId}`;
    }
    // 'all' includes series (e.g. برگزیدگان) so they can be picked as deep-link targets;
    // omitted => backend default excludes series (keeps the regular Videos admin clean).
    if (categoryType !== undefined) {
        url += `&categoryType=${categoryType}`;
    }
    const response = await getApiCaller(url);
    return response;
}

export const getVideoCategoriesDropdown = async () => {
    const response = await getApiCaller("video-category/dropdown");
    return response;
}

export const getVideoCategoryById = async (id) => {
    const response = await getApiCaller(`video-category/${id}`);
    return response;
}

export const getVideosByCategoryId = async (id, currentPage, itemsPerPage) => {
    const response = await getApiCaller(`video-category/${id}/videos?page=${currentPage}&limit=${itemsPerPage}&includeHidden=true`);
    return response;
}

export const addVideoCategory = async (payload) => {
    const response = await postFormDataApiCaller("video-category/create", payload);
    return response;
}

export const updateVideoCategory = async (id, payload) => {
    const response = await putFormDataApiCaller(`video-category/update/${id}`, payload);
    return response;
}

export const deleteVideoCategory = async (id, videoAction = null, targetCategoryId = null) => {
    const body = videoAction ? { videoAction, targetCategoryId } : null;
    const response = await deleteApiCaller(`video-category/delete/${id}`, body);
    return response;
}

export const videoCategorySequence = async (payload) => {
    const response = await putApiCaller("video-category/sequence", payload);
    return response;
}

export const getCategoryChildren = async (id) => {
    const response = await getApiCaller(`video-category/${id}/children`);
    return response;
}

export const getCategoryAncestors = async (id) => {
    const response = await getApiCaller(`video-category/${id}/ancestors`);
    return response;
}

export const swapVideoCategoryWithPage = async (payload) => {
    const response = await putApiCaller("video-category/swap-page", payload);
    return response;
}

export const previewYouTubePlaylist = async (payload) => {
    const response = await postApiCaller("video-category/youtube/preview", payload);
    return response;
}

export const importYouTubePlaylist = async (payload) => {
    const response = await postApiCaller("video-category/youtube/import", payload);
    return response;
}

export const syncYouTubePlaylist = async (id) => {
    const response = await postApiCaller(`video-category/${id}/youtube/sync`, {});
    return response;
}
